import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

var swiper = new Swiper(".headline .mySwiper", {
  effect : 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    nextEl: ".headline .swiper-button-next",
    prevEl: ".headline .swiper-button-prev",
  },
});
